import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-icon" }

import { computed, onMounted, ref, watch } from "vue";
import AppSelectField from "@/shared/components/ui/AppSelectField.vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import { fetchServiceGroups } from "@/shared/services/vendor-requests.api";


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralSetupStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const businessType = ref("");
const serviceType = ref("");
const businessEmail = ref("");
const businessPhone = ref("");
const taxId = ref("");
const isLoadingServiceTypes = ref(false);

const businessTypeOptions = [
  { label: "Sole Proprietorship", value: "sole_proprietorship" },
  { label: "Partnership", value: "partnership" },
  { label: "LLC", value: "llc" },
  { label: "Corporation", value: "corporation" },
  { label: "Freelancer", value: "freelancer" },
];

const serviceTypeOptions = ref([
  { label: "Pest Control", value: "pest_control" },
  { label: "Cleaning", value: "cleaning" },
  { label: "Plumbing", value: "plumbing" },
  { label: "Electrical", value: "electrical" },
  { label: "HVAC", value: "hvac" },
  { label: "Landscaping", value: "landscaping" },
]);

watch(
  () => props.profileInfo,
  (info) => {
    if (!info) return;
    const businessValue =
      info?.general?.business_type ||
      info?.business_type ||
      info?.business_info?.business_type ||
      info?.vendor?.business_type ||
      "";
    const serviceValue =
      info?.general?.service_category ||
      info?.service_category ||
      info?.service_type ||
      info?.business_info?.service_category ||
      info?.vendor?.service_category ||
      "";
    const businessEmailValue =
      info?.general?.business_email ||
      info?.business_email ||
      info?.business_info?.business_email ||
      info?.vendor?.business_email ||
      info?.vendor?.email ||
      "";
    const businessPhoneValue =
      info?.general?.business_phone ||
      info?.business_phone ||
      info?.business_info?.business_phone ||
      info?.vendor?.business_phone ||
      info?.vendor?.phone ||
      "";
    const taxIdValue =
      info?.general?.tax_id ||
      info?.tax_id ||
      info?.business_info?.tax_id ||
      info?.vendor?.tax_id ||
      info?.vendor?.pan_no ||
      "";

    if (!businessType.value && businessValue) businessType.value = String(businessValue);
    if (!serviceType.value && serviceValue) serviceType.value = String(serviceValue);
    if (!businessEmail.value && businessEmailValue) businessEmail.value = String(businessEmailValue);
    if (!businessPhone.value && businessPhoneValue) businessPhone.value = String(businessPhoneValue);
    if (!taxId.value && taxIdValue) taxId.value = String(taxIdValue);
  },
  { immediate: true },
);

onMounted(async () => {
  isLoadingServiceTypes.value = true;
  try {
    const response = await fetchServiceGroups();
    const list = Array.isArray(response?.data) ? response.data : [];
    if (list.length) {
      serviceTypeOptions.value = list.map((group: any) => ({
        label: group.label || group.name || group.title || "Service",
        value: group.slug || group.code || group.id,
      }));
    }
  } catch (error) {
    // Keep fallback options.
  } finally {
    isLoadingServiceTypes.value = false;
  }
});

function getErrorsForField(field: string): string[] {
  const errs: any = props.errors;
  if (!errs) return [];

  const root = errs?.errors && typeof errs.errors === "object" ? errs.errors : errs;
  const raw = root?.[field];
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map((v) => String(v));
  return [String(raw)];
}

const businessTypeErrors = computed(() => getErrorsForField("business_type"));
const serviceTypeErrors = computed(() => getErrorsForField("service_category"));
const businessEmailErrors = computed(() => getErrorsForField("business_email"));
const businessPhoneErrors = computed(() => getErrorsForField("business_phone"));
const taxIdErrors = computed(() => getErrorsForField("tax_id"));

function getValues() {
  return {
    business_email: businessEmail.value,
    business_phone: businessPhone.value,
    business_type: businessType.value,
    service_category: serviceType.value,
    tax_id: taxId.value,
  };
}

__expose({ getValues });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#e8612f"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("mdi-briefcase-outline", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "step-content" }, [
        _createElementVNode("h2", { class: "title" }, "General"),
        _createElementVNode("p", { class: "desc" }, "Choose your business type and primary service type.")
      ], -1))
    ]),
    _createVNode(_component_v_form, { class: "form" }, {
      default: _withCtx(() => [
        _createVNode(AppTextField, {
          modelValue: businessEmail.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((businessEmail).value = $event)),
          type: "email",
          label: "Business Email",
          "label-icon": "mdi-email-outline",
          placeholder: "name@company.com",
          "error-messages": businessEmailErrors.value
        }, null, 8, ["modelValue", "error-messages"]),
        _withDirectives(_createVNode(AppTextField, {
          modelValue: businessPhone.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((businessPhone).value = $event)),
          type: "tel",
          label: "Business Phone",
          "label-icon": "mdi-phone-outline",
          placeholder: "(555) 555-5555",
          "error-messages": businessPhoneErrors.value
        }, null, 8, ["modelValue", "error-messages"]), [
          [_directive_mask, '(###) ###-####']
        ]),
        _createVNode(AppSelectField, {
          modelValue: businessType.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((businessType).value = $event)),
          items: businessTypeOptions,
          "item-title": "label",
          "item-value": "value",
          label: "Business Type",
          "label-icon": "mdi-briefcase-outline",
          placeholder: "Select business type",
          "error-messages": businessTypeErrors.value
        }, null, 8, ["modelValue", "error-messages"]),
        _createVNode(AppSelectField, {
          modelValue: serviceType.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((serviceType).value = $event)),
          items: serviceTypeOptions.value,
          "item-title": "label",
          "item-value": "value",
          label: "Service Type",
          "label-icon": "mdi-shape-outline",
          placeholder: "Select service type",
          loading: isLoadingServiceTypes.value,
          disabled: isLoadingServiceTypes.value,
          "error-messages": serviceTypeErrors.value
        }, null, 8, ["modelValue", "items", "loading", "disabled", "error-messages"]),
        _createVNode(AppTextField, {
          modelValue: taxId.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((taxId).value = $event)),
          label: "Tax ID",
          "label-icon": "mdi-domain",
          placeholder: "12-3456789",
          "error-messages": taxIdErrors.value
        }, null, 8, ["modelValue", "error-messages"])
      ]),
      _: 1
    })
  ]))
}
}

})